import { render, staticRenderFns } from "./AccessPage.vue?vue&type=template&id=8d9796d8"
import script from "./AccessPage.vue?vue&type=script&lang=js"
export * from "./AccessPage.vue?vue&type=script&lang=js"
import style0 from "./AccessPage.vue?vue&type=style&index=0&id=8d9796d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports